// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1TxkP","col":"styles_col__r2SMj"};